import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ImageUrls } from "src/app/services/s3buket";

@Component({
  selector: "app-details-job-item",
  templateUrl: "./details-job-item.component.html",
  styleUrls: ["./details-job-item.component.css"]
})
export class DetailsJobItemComponent implements OnInit {

  @Input() job: any;
  @Output() onJobSaved = new EventEmitter<any>();

  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;

  constructor() { }

  ngOnInit(): void {
    this.scrollOnTop();
  }

  public saveUnsaveJob() {
    this.onJobSaved.emit(this.job);
  }
  jobSalary(job: any): string {
    let salary = "";
    if (job.price) salary = job.price + "/";
    else if (job.maximum && job.minimum) salary = job.minimum + "-$" + job.maximum + "/";
    else salary = job.minimum + job.maximum;
    if (job.rate)
      return "$" + salary + "" + job.rate.split(" ")[1];
    else
      return "$" + salary;
  }

  dateInMilisecond(date){
    const d1 = new Date(date)
    const miliSecond = d1.getTime();
    return miliSecond
  }

  scrollOnTop(){
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: "smooth" 
    });
  }
}